import React, { Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
} from "grommet";
import { Close } from "grommet-icons";
import ScaleLoader from "react-spinners/ScaleLoader";
import auth from "./Security/Auth";

class Chatapplet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bwaitloader: true,
      //UserI: auth.getUserInfo(),
    };
    // this._launchevent = this._launchevent.bind(this);
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ bwaitloader: false });
    }, 8000);
    //this._launchevent();
  }

  render() {
    var source = "";
    if (this.props.needhelp) {
      source =
        "https://demoportalchatbot.hpecic.net?user_name=" +
        this.props.uname +
        "&user_email=" +
        this.props.uemail +
        "&needhelp=yes";
    } else {
      source =
        "https://demoportalchatbot.hpecic.net?user_name=" +
        this.props.uname +
        "&user_email=" +
        this.props.uemail;
    }
    //  "https://copilotstudio.microsoft.com/environments/Default-105b2061-b669-4b31-92ac-24d304d195dc/bots/crc1d_agentrZLCQP/webchat?__version__=2";
    // this.props.UType === "Employee"
    //  ? "https://copilotstudio.microsoft.com/environments/Default-105b2061-b669-4b31-92ac-24d304d195dc/bots/crc1d_agentZr2htE/webchat?__version__=2"
    //   : "https://copilotstudio.microsoft.com/environments/Default-105b2061-b669-4b31-92ac-24d304d195dc/bots/crc1d_agentrZLCQP/webchat?__version__=2";

    console.log("User Type is", this.props.UType);
    console.log(this.props.UType === "Employee");
    console.log("source is ", source);
    return (
      <Layer
        position="center"
        // full="vertical"
        modal
        margin={{ right: "medium" }}
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
        //onClickOutside={onClose}
        //onEsc={onCl
        // ose}
      >
        <Box
          align="end"
          justify="end"
          direction="row"
          // margin={{ top: "large" }}
          gap="medium"
          fill="horizontal"
          background={{ color: "brand" }}
        >
          <Button icon={<Close />} secondary onClick={this.props.hide} />
        </Box>
        <iframe
          style={{ height: "600px", width: "800px", minHeight: "500px" }}
          src={source}
          allowFullScreen
          webkitallowFullScreen
          mozAllowFullScreen
        ></iframe>
        {this.state.bwaitloader && (
          <ScaleLoader
            color="#008000"
            height={20}
            speedMultiplier={2}
            width={5}
          />
        )}
      </Layer>
    );
  }
}

export default Chatapplet;
